export const idPlanoCristalia = 142326;
export const idPlanoUniaoQuimica = 91021;
export const idPlanoMinhaDII = 79721;